<template>
  <div class="navbar-transparent">
    <!--        声音开关-->
    <!--<img @click="switchLanguageBroadcast"
         width="17px"
         :src=" voice === 'true' ?  require('@/assets/images/overall_situation/0.png') : require('@/assets/images/overall_situation/1.png')"
         class="pointer float-left voiceIcon">-->

    <b-nav-item-dropdown class="dropdownNav" right style="display: inline-block" text="Lang">
      <template #button-content>
        <b-avatar
          :src="account.avatar ? $ftpUrl + account.avatar : require('@/assets/images/default/user_avatar_default.png')"
          class="mr-1" size="sm"></b-avatar>
        <strong class="text-lightBlue">{{ accountName }}</strong>
        <b-icon aria-hidden="true" class="ml-1 text-lightBlue" icon="gear-fill"></b-icon>
      </template>
      <b-dropdown-item> [ {{ account.code }} ]</b-dropdown-item>
      <b-dropdown-item @touchstart="newPage(iamUrl)" @click="newPage(iamUrl)" href="#">个人资料</b-dropdown-item>
      <b-dropdown-item @touchstart="logout" @click="logout" href="#">退出登录</b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>

<script>
import {getSystematicByCodes} from "@/network/systematic";
import {cancel, getCookie, playRead, setCookie} from "@/utils/common";
import {getAlarmByCommitTimeAsc} from "@/network/alarm-realtime";
import {logout, redirectLogin} from "@/network/sso";
import {getAccountInfo} from "@/network/account";

export default {
  name: "CommonMenu",
  data() {
    return {
      account: {},
      accountDetail: {},
      accountName: '',
      iamUrl: window.g.iamUrl + '?index=personal/index',
      voice: true,
    }
  },
  created() {
    this.voice = getCookie("audioAlarm");
    this.getAccountInfo();
  },
  watch: {
    voice() {
      this.voice = getCookie("audioAlarm")
    }
  },
  methods: {
    // 新页面调转
    newPage(pageUrl) {
      this.$emit('newPage', pageUrl)
    },
    //语音播报开关
    switchLanguageBroadcast: function () {
      getSystematicByCodes(["voiceWarningNotification"]).then(res => {
        if (res.code === 0) {
          if (res.data[0].code === "voiceWarningNotification" && res.data[0].val1 === 'true') {
            if (this.voice === 'true') { //停止
              setCookie("audioAlarm", false, null);
              cancel();
              this.voice = 'false';
              this.$message({
                message: "声音播报已关闭",
                type: 'info'
              });
             } else { //开启
               this.voice = 'true';
               setCookie("audioAlarm", true, null);
               // 立即显示开启提示
               this.$message({
                 message: "正在开启声音播报...",
                 type: 'info',
                 duration: 1500
               });
               // 先清除可能存在的旧语音，然后延迟一下再播放新的
               cancel();
               setTimeout(() => {
                 // 传入已获取的配置，避免重复请求
                 this.startVoice(res.data[0]);
               }, 200);
             }
          } else {
            this.$message({
              message: "请先开启声音通知配置",
              type: 'warning'
            });
          }
        }
      })
    },

    //开启语音（config参数可选，如果传入则直接使用，不传则会重新请求）
    startVoice(config = null) {
      // 重置语音播放状态，并标记用户已交互（点击开启按钮本身就是交互）
      if (window.app) {
        window.app.isVoicePlaying = false;
        window.app.hasUserInteracted = true; // 用户主动开启声音，标记已交互
      }
      
      // 刷新当前路由页面的数据（如果是实时告警页面）
      if (this.$route.path === '/realTime-alarm') {
        // 通知实时告警页面刷新数据
        this.$root.$emit('refreshAlarmData');
      }
      
      // 如果传入了配置，直接使用，避免重复请求
      if (config && config.code === "voiceWarningNotification" && config.val1 === 'true') {
        getAlarmByCommitTimeAsc().then(alarm => {
          if (alarm.data != null && alarm.data.length > 0) {
            setCookie("audioAlarm", true, null);
            this.$message({
              message: "声音播报已开启，正在播放" + alarm.data.length + "条告警",
              type: 'success'
            });
            for (var i = 0; i < alarm.data.length; i++) {
              playRead(alarm.data[i].msg);
            }
          } else {
            this.$message({
              message: "声音播报已开启，当前暂无告警",
              type: 'info'
            });
          }
        })
      } else {
        // 没有传入配置，则重新请求配置（保持向后兼容）
        getAlarmByCommitTimeAsc().then(alarm => {
          if (alarm.data != null && alarm.data.length > 0) {
            //语音播报
            getSystematicByCodes(["voiceWarningNotification"]).then(res => {
              if (res.code === 0) {
                if (res.data[0].code === "voiceWarningNotification") {
                  setCookie("audioAlarm", true, null);
                  if (res.data[0].val1) {
                    this.$message({
                      message: "声音播报已开启，正在播放" + alarm.data.length + "条告警",
                      type: 'success'
                    });
                    for (var i = 0; i < alarm.data.length; i++) {
                      playRead(alarm.data[i].msg);
                    }
                  }
                }
              }
            })
          } else {
            this.$message({
              message: "声音播报已开启，当前暂无告警",
              type: 'info'
            });
          }
        })
      }
    },
    //退出登录
    logout() {
      logout().then(res => {
        console.log(res)
      })
      redirectLogin()
    },
    getAccountInfo() {
      getAccountInfo().then(res => {
        this.account = res.data.account
        this.accountDetail = res.data.accountDetail
        if (this.account.nickname) {
          this.accountName = this.account.nickname
        } else if (this.accountDetail.name) {
          this.accountName = this.accountDetail.name
        } else {
          this.accountName = this.account.code
        }
      })
    },
  }
}
</script>

<style scoped>
.nav-link {
  color: #07E6F8;
}

.voiceIcon {
  margin-top: 12px;
}

@media (max-width: 1400px) {
  .voiceIcon {
    margin-top: 10px;
  }
}

@media (max-width: 1198px) {
  .voiceIcon {
    margin-top: 8px;
  }
}

.nav-item >>> .dropdown-toggle::after {
  display: none;
}
</style>
